import { PropsWithChildren } from "react";
import * as Styled from './Card.styled';


type CardProps = PropsWithChildren<{}>;

export const Card = ({ children }: CardProps) => (
    <Styled.StyledCard>
        {children}
    </Styled.StyledCard>
);
